import classNames from "classnames";
import { isNil } from "lodash";

import { simplePercentageFilter } from "app/filters/ngFilters";

import type { ITableCellProps } from "../interfaces/ITableCellProps";

/**
 * @deprecated Use ChangeCell from @similarweb/pro-logic-components instead
 * @see {@link https://gitlab.int.similarweb.io/pro-frontend/pro-logic-components/-/blob/master/src/table/cells/components/views/change-cell/ChangeCell.tsx}
 */

export const PercentPointCell = ({ value, row }: Pick<ITableCellProps, "value" | "row">) => {
    const isInverted = row?.isInverted;

    const iconClasses = classNames("changePercentage-icon", {
        "sw-icon-arrow-up5": value > 0,
        "sw-icon-arrow-down5": value < 0,
    });

    const classes = classNames("changePercentage", {
        negative: isInverted ? value > 0 : value < 0,
        positive: isInverted ? value < 0 : value > 0,
    });

    const precision = row?.precision ?? 2;
    const filteredValue = simplePercentageFilter()(Math.abs(value), precision);

    let ppValue = isNil(value) ? "-" : `${filteredValue} pp`;
    if (filteredValue === 0) {
        ppValue = value > 0 ? `< 0.01 pp` : value < 0 ? `> 0.01 pp` : `-`;
    }

    return (
        <div className={classes}>
            <i className={iconClasses} /> {ppValue}
        </div>
    );
};

PercentPointCell.displayName = "PercentPointCell";
